import React from 'react';
import { IconFunil } from '@paretogroup/tess';
import { ColorConstants } from '@shared/constants';
import { SEGMENTS_FILTER_ICON_TEST_ID } from './segments-filter-icon.constants';
import { FilterIconWrapper } from './segments-filter-icon.styles';

interface SegmentsFilterIconProps {
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    isDesktop?: boolean;
    primaryColor?: string;
    secondaryColor?: string;
    size?: number;
}

export const SegmentsFilterIcon = ({
    onClick,
    isDesktop,
    primaryColor = ColorConstants['regal-blue-20%'],
    secondaryColor = ColorConstants.white,
    size,
    ...rest
}: SegmentsFilterIconProps) => (
    <FilterIconWrapper
        data-testid={SEGMENTS_FILTER_ICON_TEST_ID}
        onClick={onClick}
        isDesktop={isDesktop}
        {...rest}
    >
        <IconFunil
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            size={size}
        />
    </FilterIconWrapper>
);
